import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connectSortBy } from 'react-instantsearch-dom';
import { Radio } from 'ck-ui';
import { NbHits } from './NbHits';
import { ProductListingPageContext } from '../context';
import { AsideToggle } from './AsideToggle';
import styles from './SortFilter.module.scss';
import { FacetContainer } from '../facets';

const MobileSortBy = connectSortBy(({ currentRefinement, refine, items }) => (
  <FacetContainer
    label="Sort By"
    forceOpen
    render={() => (
      items.map(item => (
        <label key={item.value} className="facet-label">
          <Radio checked={item.value === currentRefinement} onChange={() => refine(item.value)}>
            <span className="is-capitalized">
              {item.label}
            </span>
          </Radio>
        </label>
      ))
    )}
  />
));

const DesktopSortBy = connectSortBy(({ currentRefinement, refine, items }) => (
  <select value={currentRefinement} onChange={(e) => refine(e.target.value)}>
    {items.map(item => (
      <option key={item.value} value={item.value}>
        {item.label}
      </option>
    ))}
  </select>
));

const SortFilter = ({ INDEX, defaultIndex, className }) => {
  const { isMobile } = useContext(ProductListingPageContext);

  const index = defaultIndex || INDEX;
  const label = defaultIndex ? 'Featured' : 'Relevance';
  const items = isMobile ? [
    {
      value: index,
      label
    },
    {
      value: `${INDEX}_published_at_desc`,
      label: 'Date: New to Old'
    },
    {
      value: `${INDEX}_price_asc`,
      label: 'Price: Low to High'
    },
    {
      value: `${INDEX}_discount_amount_desc`,
      label: 'Discount $: High to Low'
    },
    {
      value: `${INDEX}_discount_percentage_desc`,
      label: 'Discount %: High to Low'
    },
    {
      value: `${INDEX}_price_desc`,
      label: 'Price: High to Low'
    },
  ] : [
    {
      value: index,
      label: `Sort By: ${label}`
    },
    {
      value: `${INDEX}_published_at_desc`,
      label: 'Sort By: Date: New to Old'
    },
    {
      value: `${INDEX}_price_asc`,
      label: 'Sort By: Price: Low to High'
    },
    {
      value: `${INDEX}_discount_amount_desc`,
      label: 'Sort By: Discount $: High to Low'
    },
    {
      value: `${INDEX}_discount_percentage_desc`,
      label: 'Sort By: Discount %: High to Low'
    },
    {
      value: `${INDEX}_price_desc`,
      label: 'Sort By: Price: High to Low'
    },
  ];

  if (isMobile) {
    return <AsideToggle mobileSortBy={<MobileSortBy items={items} defaultRefinement={index} />} />;
  }

  return (
    <div>
      <div className={`${styles.container} ${className}`}>
        <NbHits />
        <DesktopSortBy items={items} defaultRefinement={index} />
      </div>
    </div>
  );
};

SortFilter.propTypes = {
  INDEX: PropTypes.string.isRequired,
  defaultIndex: PropTypes.string,
  className: PropTypes.string,
};

SortFilter.defaultProps = {
  defaultIndex: null,
  className: null,
};

export { SortFilter };
